import VideoHero from "../components/VideoHero.jsx";
import TreatmentsCards from "../components/TreatmentsCards.jsx";
import ApproachToWellnessSection from "../components/ApproachToWellnessSection.jsx";
import FeaturesSection from "../components/FeaturesSection.jsx";
import TeamSection from "../components/TeamSection.jsx";
import TestimonialsSection from "../components/TestimonialsSection.jsx";
import SEO from "../components/SEO.jsx";

const Home = () => {
  return (
    <div>
      <SEO
        title="Home"
        description="Bioresonance Leicester – complementary wellness and bioresonance therapy in Leicester. BICOM-certified practitioners, EU-approved devices. Book your consultation at 108 New Walk."
        path="/"
      />
      <VideoHero />
      <TreatmentsCards />
      <ApproachToWellnessSection />
      <FeaturesSection />
      <TeamSection />
      <TestimonialsSection />
    </div>
  );
};

export default Home;